<div class="card-list" (mouseleave)="expanded ? null : onMouseLeave()">
  @for (page of tournaments; track $index; let i = $index) {
    @for (tournament of page.items; track tournament; let i = $index) {
      <div
        class="card-list__item"
        (mouseenter)="onMouseHover($event, tournamentGameCard, tournament)"
      >
        <ng-container
          [ngTemplateOutlet]="tournamentGameCard"
          [ngTemplateOutletContext]="{
            tournament: tournament,
            last: i + 1 === tournaments.length
          }"
        ></ng-container>
      </div>
    }
  }
</div>

<ng-template
  #tournamentGameCard
  let-tournament="tournament"
  let-last="last"
  let-opened="opened"
  let-hovered="hovered"
>
  <fz-game-card
    fzObserveElement
    #intersection="intersection"
    (isIntersecting)="isIntersecting($event, last)"
    [tournament]="tournament"
    [expandOnHover]="true"
    [disableExtraData]="true"
    (selected)="onTournamentPress(tournament)"
    (share)="onTournamentShare(tournament)"
    [cardRightTag]="cardRightTag"
    [opened]="opened"
    [hovered]="hovered"
    (previewPress)="onPreviewPress(tournament, tournamentGameCard, $event)"
    (mouseleave)="hovered ? onMouseLeave() : null"
  >
    <!-- prize range -->
    <fz-game-card-prize
      *ngIf="!tournament?.lifeExperience"
      [range]="tournament?.prizeRange?.min !== tournament?.prizeRange?.max"
      [prize]="tournament?.prizeRange?.min"
      [prizeRangeEnd]="tournament?.prizeRange?.max"
    ></fz-game-card-prize>

    <!-- prize image -->
    @if (tournament.lifeExperience) {
      <fz-game-card-prize-description
        [title]="getTitle(tournament)"
        [content]="getDescription(tournament)"
        [imgUrl]="
          tournament.prizeDetails?.prizeImageAvatar.url ||
          tournament.prizeDetails?.prizeImageAvatar
        "
      ></fz-game-card-prize-description>
    } @else {
      <fz-game-card-description>
        {{ tournament?.description }}
      </fz-game-card-description>
    }

    <!-- date indicator -->
    <fz-game-card-time
      [start]="tournament.casualGameStartTime"
      [end]="tournament.casualGameEndTime"
    ></fz-game-card-time>

    <!-- tournament tags -->
    @if (tournament.metadata && tournament.metadata?.tags) {
      <fz-game-card-tags [tags]="tournament.metadata.tags"></fz-game-card-tags>
    }

    <!-- Top right label -->
    <ng-template #cardRightTag>
      <!-- Completed label -->
      <div
        *ngIf="tournament.comingSoon && !tournament.isComplete"
        class="fz-game-card__tag__coming-soon"
      >
        Coming soon
      </div>

      <!-- Coming soon label -->
      @if (tournament.isComplete && !tournament.ended) {
        <div class="fz-game-card__tag__completed">Completed</div>
      }

      @if (tournament.ended) {
        <div class="fz-game-card__tag__ended">Ended</div>
      }

      @if (
        !tournament.ended &&
        !tournament.comingSoon &&
        !tournament.isComplete &&
        tournament.lifeExperience
      ) {
        <div>
          <fz-currency
            [value]="tournament.eventSchedules[0].entryAmount || 0"
          ></fz-currency>
        </div>
      }

      <!-- Prize label -->
      @if (
        !tournament.comingSoon &&
        !tournament.isComplete &&
        !tournament.lifeExperience
      ) {
        <div>
          From
          <fz-currency [value]="tournament?.entryFeeRange?.start"></fz-currency>
        </div>
      }
    </ng-template>
  </fz-game-card>
</ng-template>

@if (expanded) {
  <fz-expanded-card
    [mode]="expanded.mode || 'default'"
    [source]="expanded.source"
    [template]="expanded.template"
    [tournament]="expanded.tournament"
    (mouseLeave)="onMouseLeave()"
  ></fz-expanded-card>
}
